import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const COVERAGE_SEARCH_BY_OPTIONS = gql`
  query CoverageSearchByOptions($policyId: ID) {
    electionSearchByFields(policyId: $policyId)
  }
`;

export default function useCoverageSearchByOptions({ policyId }) {
  const { loading, error, data } = useQuery(COVERAGE_SEARCH_BY_OPTIONS, {
    variables: { policyId },
    onCompleted: () => {},
    onError: () => {}
  });

  return {
    coverageSearchByOptions:
      data?.electionSearchByFields?.map(field => ({
        label: backendNameToLabel(field),
        value: field
      })) || [],
    loading,
    error
  };
}
